import { Button, Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';
import { PrettyOptions } from '@pelicargo/utils';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

type Props<T extends string | number> = {
  filters: RequestFilters;
  handleCheckboxFilterChange: (key: string) => (nextValue: string[]) => void;
  resetView: () => void;
  name: string;
  field: string;
  options: PrettyOptions<T>[];
};

export const SimpleFilter = <T extends string | number>({
  filters,
  handleCheckboxFilterChange,
  resetView,
  name,
  field,
  options,
}: Props<T>) => (
  <Stack spacing="2" pt="2">
    <Stack direction="row" align="center" spacing="2">
      <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
        {name}
      </Button>
    </Stack>

    <CheckboxGroup value={filters[field]} onChange={handleCheckboxFilterChange(field)}>
      {options?.map(({ label, value }) => (
        <Checkbox key={value} value={value}>
          {label}
        </Checkbox>
      ))}
    </CheckboxGroup>
  </Stack>
);
